// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 性别枚举 枚举类
 * 性别枚举
 */
export enum EnumGender {
  /** 保密 : 保密 */
  None = 0,
  /** 男性 : 男性 */
  Male = 1,
  /** 女性 : 女性 */
  Female = 2
}

/**
 * 性别枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumGenderMD {
  private static items = [
    new EnumItemMD('None', 0, '保密', '保密'),
    new EnumItemMD('Male', 1, '男性', '男性'),
    new EnumItemMD('Female', 2, '女性', '女性')
  ];

  static getItem(enumItem: EnumGender) {
    return this.items.find(item => item.name === EnumGender[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
